/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a friend organisation
 * @export
 * @interface BridgeApiFriendOrganisationV2
 */
export interface BridgeApiFriendOrganisationV2 {
    /**
     * 
     * @type {string}
     * @memberof BridgeApiFriendOrganisationV2
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiFriendOrganisationV2
     */
    name: string;
}

/**
 * Check if a given object implements the BridgeApiFriendOrganisationV2 interface.
 */
export function instanceOfBridgeApiFriendOrganisationV2(value: object): value is BridgeApiFriendOrganisationV2 {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function BridgeApiFriendOrganisationV2FromJSON(json: any): BridgeApiFriendOrganisationV2 {
    return BridgeApiFriendOrganisationV2FromJSONTyped(json, false);
}

export function BridgeApiFriendOrganisationV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiFriendOrganisationV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function BridgeApiFriendOrganisationV2ToJSON(json: any): BridgeApiFriendOrganisationV2 {
    return BridgeApiFriendOrganisationV2ToJSONTyped(json, false);
}

export function BridgeApiFriendOrganisationV2ToJSONTyped(value?: BridgeApiFriendOrganisationV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

